export const BRAKE_SYSTEM = {
  MRP_PRESS_MIN_LIMIT: 7,
  STATUS: {
    C_PRESS_HOSE_BRAKE: 1,
    BRAKE_NOT_RELEASED: 1,
    BRAKE_NOT_APPLIED: 1,
    DIRECT_BRAKE_DIST: 1,
    AIR_SUSP_PRESS_FAULT: 0,
    AIR_SUSP_PRESS_INVALID: 1,
    WSP_FAILURE: 1,
    BRAKE_UNIT_APPLIED_RELEASED: 1
  }
} as const;
